export default __webpack_public_path__ + "static/media/ATOM.1239290a.png";